import React from 'react';
import { CodPaisCellRenderer } from "../../../../../../shared/components/CustomCells/CodPaisCellRenderer";
import { LinkDrillDown } from '../../../../../../shared/components/CustomCells/LinkDrillDown';
import { ColumnsFactory } from "../../../../../../shared/components/Grid/functions";

export const getColumnDefs = (props) => {

  const {onClickDrillDown} = props

  const LinkCell = (params) =>{
    return <LinkDrillDown params={params} onClickDrillDown={onClickDrillDown} dataOption='codPais'/>
  }

  return [
    ColumnsFactory.TextColumn("Cód. País", "codPais", {cellRendererFramework: CodPaisCellRenderer}),
    ColumnsFactory.TextColumn("País", "pais"),
    ColumnsFactory.DecimalColumn("Horas", "nHoras")
  ]
};